import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { Slider } from '../entities/slider';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@mobileia/authentication';
import { MIATableModel, ApiResponse, ApiPagination } from '@mobileia/core';
import { Category } from '../entities/category';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends BaseTableService<Category> {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
    this.basePathUrl = 'admin/category';
  }

  fetchAll(): Observable<ApiResponse<ApiPagination<Category>>> {
    let params = new MIATableModel();
    params.itemPerPage = 10000;
    return this.postAuthObject(environment.baseUrl + this.basePathUrl + '/list', params.toParams());
  }
  
  fetchParents(): Observable<ApiResponse<ApiPagination<Category>>> {
    let params = new MIATableModel();
    params.addWhere('parent_id', '0');
    return this.postAuthObject(environment.baseUrl + this.basePathUrl + '/list', params.toParams());
  }
}
